import React, { useState } from "react";
import classNames from "./style.module.css";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const topButtonsValues = [
  { text: "BASIN BÜLTENİ", value: 0 },
  { text: "DERECE ALAN OKULLAR", value: 1 },
  { text: "FOTOĞRAF GALERİSİ", value: 2 },
  // { text: "AKTİF YARIŞMALAR", value: 3 },
];

export default () => {
  const [selectedMenu, setSelectedMenu] = useState(0);
  const topButtons = (
    <ButtonGroup
      size="large"
      color="secondary"
      aria-label="large outlined primary button group"
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px",
        padding: "10px"
      }}
    >
      {topButtonsValues.map((b) => {
        return (
          <Button
            onClick={() => setSelectedMenu(b.value)}
            key={b.value + "topButton"}
            style={{ 
              color: "white", 
              fontWeight: 200,
              fontSize: window.innerWidth < 768 ? "14px" : "16px",
              padding: window.innerWidth < 768 ? "8px 12px" : "12px 24px",
              whiteSpace: "nowrap"
            }}
          >
            {b.text}
          </Button>
        );
      })}
    </ButtonGroup>
  );

  return (
    <div className={classNames.pageContainer}>
      {topButtons}
      {selectedMenu === 0 && <Bulten />}
      {selectedMenu === 1 && <MedahallOfFame />}
      {selectedMenu === 2 && <PhotoGallery />}
      {/* {selectedMenu === 3 && <ActiveCompetitions />} */}
    </div>
  );
};

const MedahallOfFame = () => {
  const generateMedal = ({
    medalType,
    schoolLogoPath,
    schoolName,
    studentList,
    tutorList,
  }) => {
    const silverMedal = (
      <img src="/assets/images/medals/silver.png" alt="silver" />
    );
    const goldMedal = <img src="/assets/images/medals/gold.png" alt="gold" />;
    const bronzeMedal = (
      <img src="/assets/images/medals/bronze.png" alt="bronze" />
    );

    const medalImage =
      medalType === "gold"
        ? goldMedal
        : medalType === "silver"
        ? silverMedal
        : bronzeMedal;

    const schoolLogoImage = (
      <div>
        <img
          src={schoolLogoPath ? schoolLogoPath : "/assets/images/meb-logo.png"}
          alt="home-logo"
          width="120"
          height="120"
        />
      </div>
    );

    const schoolNameSpan = (
      <div
        style={{
          marginTop: 30,
          fontSize: "24px",
          fontWeight: "bolder",
          color: "#15273A",
        }}
      >
        {toTurkishTitleCase(schoolName)}
      </div>
    );

    const studentListBox = (
      <div style={{ marginTop: 15 }}>
        <div style={{ fontSize: "24px", color: "#E79121" }}>Takım</div>
        {studentList.map((s) => (
          <div style={{ fontSize: "20px", textTransform: "capitalize" }}>
            {toTurkishTitleCase(s)}
          </div>
        ))}
      </div>
    );

    const tutorListBox = (
      <div style={{ marginTop: 15 }}>
        <div style={{ fontSize: "24px", color: "#E79121" }}>
          Sorumlu Öğretmen
        </div>
        {tutorList.map((t) => (
          <div style={{ fontSize: "20px", textTransform: "capitalize" }}>
            {toTurkishTitleCase(t)}
          </div>
        ))}
      </div>
    );
    return (
      <div
        style={{
          borderRadius: "15px",
          position: "relative",
          width: 339,
          height: 633,
          textAlign: "center",
          lineHeight: 1.1,
          margin: 10,
        }}
      >
        {medalImage}
        <div
          style={{
            position: "absolute",
            top: 150,
            textAlign: "center",
            width: 338,
            paddingLeft: 27,
            paddingRight: 27,
          }}
        >
          {schoolLogoImage}
          {schoolNameSpan}
          {studentListBox}
          {tutorListBox}
        </div>
      </div>
    );
  };

  const generateMedalGroup = ({ groupName, groupItems }) => {
    const isMobile = window.innerWidth < 768; // Mobil kontrolü

    const styles = {
      display: "flex",
      alignItems: "center",
      justifyContent: isMobile ? "center" : "space-between",
      fontSize: isMobile ? "18px" : "42px",
      paddingBottom: 20,
      borderBottom: "solid #DA571A 2px",
      marginBottom: 20,
      lineHeight: 1,
    };

    const header = (
      <div style={styles}>
        <span style={{ color: "#DA571A", textAlign: "left" }}>
          Türkiye Finalleri Sonuçları
        </span>
        <span style={{ color: "#15273A", fontWeight: "bold", marginLeft: 30 }}>
          {groupName}
        </span>
      </div>
    );

    return (
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 15,
          padding: 20,
          maxWidth: 1200,
          margin: 20,
        }}
      >
        {header}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {groupItems}
        </div>
      </div>
    );
  };

  //BİRİNCİ SINIF
  const birinciSinifMedals = generateMedalGroup({
    groupName: "Birinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "",
        schoolName: "MEHMET PAŞA İLKOKULU",
        studentList: ["Azra Uçan", "Çağdaş Ata Karakuş", "Çınar Demir"],
        tutorList: ["Hüseyin Nazım Karakuş"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "",
        schoolName: "AVNİ AKYOL İLKOKULU",
        studentList: ["Masal Şahin"],
        tutorList: [],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fbilfen-iskenderun-oo-logo.png?alt=media&token=9f8bade1-fcab-4a74-9217-99602a95b7ce",
        schoolName: "ÖZEL BİLFEN İSKENDERUN İLKOKULU",
        studentList: ["Ali Çam", "Demir Sabahoğlu", "Murat Çakıcı"],
        tutorList: ["Derya Uyar"],
      }),
    ],
  });

  //İKİNCİ SINIF
  const ikinciSinifMedals = generateMedalGroup({
    groupName: "İkinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkartal_bilsem.jpeg?alt=media&token=bc97a8d3-849c-4bf0-bf96-71692368c1a9",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Ela Gencer", "Elif Karaca", "Su Defne Tirebolu"],
        tutorList: ["Umut Bektaş"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fbartin_bilsem_logo.jpg?alt=media&token=2fd02bc3-9c87-4f41-a819-a8d1422a4337",
        schoolName: "BARTIN BİLİM VE SANAT MERKEZİ",
        studentList: ["Ömer Kayra Küçük"],
        tutorList: ["Mustafa Sayim"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "",
        schoolName: "GAZİPAŞA İLKOKULU",
        studentList: ["Ahmet Atlas Özmen", "Emin Durna", "Kutlu Karaduman"],
        tutorList: ["Evren Zeytin"],
      }),
    ],
  });

  //ÜÇÜNCÜ SINIF
  const ucuncuSinifMedals = generateMedalGroup({
    groupName: "Üçüncü Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkartal_bilsem.jpeg?alt=media&token=bc97a8d3-849c-4bf0-bf96-71692368c1a9",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Ares Mehmet Keleş", "Ertuğrul Büyükarmutçu", "Mert Bal"],
        tutorList: ["Umut Bektaş"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fbilfen-iskenderun-oo-logo.png?alt=media&token=9f8bade1-fcab-4a74-9217-99602a95b7ce",
        schoolName: "ÖZEL BİLFEN ÇAYYOLU İLKOKULU",
        studentList: ["Halil Demir Kayan", "Mert Badik", "Toprak Altun"],
        tutorList: ["Canan Duran"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:"https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Ffatih_logo.jpg?alt=media&token=6c218b71-d69e-4236-904e-6b2cb5e43164",
        schoolName: "FATİH İLKOKULU",
        studentList: ["Deniz Efe Güngörür", "İshak Susar", "Selman Bat"],
        tutorList: ["İlyas Erel"],
      }),
    ],
  });

  ///DÖRDÜNCÜ SINIF
  const dorduncuSinifMedals = generateMedalGroup({
    groupName: "Dördüncü Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fusak_mehmetcik.jpg?alt=media&token=56271c7d-effc-4843-a028-236e9c642b46",
        schoolName: "MEHMETÇİK İLKOKULU",
        studentList: ["Egemen Dural", "Elif Ezgi Erdoğan", "Mehmet Dörttepe"],
        tutorList: ["Döndü Şahin"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fpendil.jpg?alt=media&token=cc6a602b-d813-4f94-baca-a67e946a06fc",
        schoolName: "PENDİK BİLİM VE SANAT MERKEZİ",
        studentList: ["Halit Yusuf Yılmaz", "İsmail Karakuyu", "Melisa Çolak"],
        tutorList: ["Songül Özgenel"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fantalya-bilsem.png?alt=media&token=ae40804d-d885-46d6-9612-4021570229a4",
        schoolName: "ANTALYA BİLİM VE SANAT MERKEZİ",
        studentList: ["Halis Emre Şimşir", "Sözel Çağan Tuğra", "Yiğit Atik"],
        tutorList: ["Arzu Arık"],
      }),
    ],
  });
 

  //// BEŞİNCİ SINIF
  const besinciSinifMedals = generateMedalGroup({
    groupName: "Beşinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkadikoy_bilsem.jpeg?alt=media&token=1ba2d612-037c-41f3-8c80-f7c4a318b069",
        schoolName: "KADIKÖY BİLİM VE SANAT MERKEZİ",
        studentList: ["Boran Serhat Kaya", "Kaan Pektaş", "Verda İdil Yılmaz"],
        tutorList: ["Yudum Özer"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fsidika_cal%C4%B1skan.jpg?alt=media&token=e2776ded-47ee-4360-bfdf-2bbd47750aba",
        schoolName: "SIDIKA ÇALIŞKAN ORTAOKULU",
        studentList: ["Burak Saluç", "Emir Ege Arslanyörür", "Kerem Tarım"],
        tutorList: ["Kerim Bulut"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkartal_bilsem.jpeg?alt=media&token=bc97a8d3-849c-4bf0-bf96-71692368c1a9",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Ali Asım Cebeci", "Aslı Gülce Arlı", "Muhammet Ali Bilgin"],
        tutorList: ["Umut Bektaş"],
      }),
    ],
  });

  //ALTINCI SINIF
  const altinciSinifMedals = generateMedalGroup({
    groupName: "Altıncı Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fsidika_cal%C4%B1skan.jpg?alt=media&token=e2776ded-47ee-4360-bfdf-2bbd47750aba",
        schoolName: "SIDIKA ÇALIŞKAN ORTAOKULU",
        studentList: ["Ceyda Yaşar", "Doğukan Oruç", "Fevzi Anıl Hançarlı"],
        tutorList: ["Kerim Bulut"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2F%C3%BClker-y%C3%B6r%C3%BCko%C4%9Flu.jpg?alt=media&token=f135a97d-33d3-4076-864d-e12055970463",
        schoolName: "ÜLKER YÖRÜKOĞLU BİLİM VE SANAT MERKEZİ",
        studentList: ["Oğuzhan Uzun", "Sarp Zeki Kartallar", "Yağız Ege İlçioğlu"],
        tutorList: ["Kadir Alper Çetin"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fd%C3%B6nence.jpg?alt=media&token=4406f94d-8edf-4798-aa90-4d98dac2beb5",
        schoolName: "ÖZEL DÖNENCE ORTAOKULU",
        studentList: ["Ahmet Burak Tali", "Bedirhan Ali Dayan", "Sare Arpaç"],
        tutorList: ["Emine Yahşi"],
      }),
    ],
  });

    //YEDİNCİ SINIF
  const yedinciSinifMedals = generateMedalGroup({
    groupName: "Yedinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2FKahramankazan_ANKARA%20S%CC%A7ahin%20Ortaokulu.jpg?alt=media&token=7ed55490-96e1-4c0e-92a8-4410289e6cb9",
        schoolName: "ŞAHİN ORTAOKULU",
        studentList: ["Elifnaz Demirkıran", "Yusuf Furkan Şahin", "Zümra Karakoç"],
        tutorList: ["Derya Hızarcıoğlu"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2FEyubogluEgitimKurumlari.jpg?alt=media&token=dc538755-378d-4ee5-a8bc-3605a1bc6c9c",
        schoolName: "ÖZEL BURÇAK EYÜBOĞLU BATI ATAŞEHİR ORTAOKULU",
        studentList: ["Can Evren", "Kaan Evren"],
        tutorList: ["Aybüke Karagözler İlkdoğan"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkadikoy_bilsem.jpeg?alt=media&token=1ba2d612-037c-41f3-8c80-f7c4a318b069",
        schoolName: "KADIKÖY BİLİM VE SANAT MERKEZİ",
        studentList: ["Asya Mercan Özşahin", "Can Ozan Özşahin", "Emre Şahin"],
        tutorList: ["Yudum Özer"],
      }),
    ],
  });

  //SEKİZİNCİ SINIF
  const sekizinciSinifMedals = generateMedalGroup({
    groupName: "Sekizinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Ftuhan-ak%C3%A7ay.jpg?alt=media&token=552e80ce-1c6d-441e-b559-b059fcf03210",
        schoolName: "TURHAN AKÇAY BİLİM VE SANAT MERKEZİ",
        studentList: ["Eren Boyalı", "Erhan Alp", "Rüzgar Kayra Topbay"],
        tutorList: ["Emre Gülmez"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fkartal_bilsem.jpeg?alt=media&token=bc97a8d3-849c-4bf0-bf96-71692368c1a9",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Eymen Karayavuz", "Yusuf Numan Keskin"],
        tutorList: ["Umut Bektaş"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fmugla-bilsem.png?alt=media&token=d88fa81b-851f-4bf7-bcb9-28d15d5e6c0c",
        schoolName: "MUĞLA BİLİM VE SANAT MERKEZİ",
        studentList: ["Ahmet Kağan İnanç", "Emir Sarı", "Halit Buğra Işık"],
        tutorList: ["Melek Yıldırım"],
      }),
    ],
  });

  //DOKUZUNCU SINIF
  const dokuzuncuSinifMedals = generateMedalGroup({
    groupName: "Dokuzuncu Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fistanbul-erkek.png?alt=media&token=c021b917-d90d-42ca-b24e-18b1d0832c79",
        schoolName: "İSTANBUL ERKEK LİSESİ",
        studentList: ["Duru Özbolat", "Eda Cerit", "Zümra Kocakarin"],
        tutorList: ["Murat Yoğurtçu"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "",
        schoolName: "HAYDARPAŞA LİSESİ",
        studentList: ["Beril Demirel", "Duru Ada Ünlü", "İrfan Musabeşeoğlu"],
        tutorList: ["Fuat Ses"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fistanbul-amerikan-robert-lisesi-robert-college-logo-png_seeklogo-216171.png?alt=media&token=9e59baee-18b4-4531-bb60-e588a4c289f8",
        schoolName: "ÖZEL AMERİKAN ROBERT LİSESİ",
        studentList: ["Kağan Kumcu", "Kuzey Hoşafcı", "Yusuf Çukuril"],
        tutorList: [],
      }),
    ],
  });

  //ONUNCU SINIF
  const onuncuSinifMedals = generateMedalGroup({
    groupName: "Onuncu Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2FErbak%C4%B1r_Fen_Lisesi.jpg?alt=media&token=34152bf5-4661-449c-a6e0-a6b9fab965a8",
        schoolName: "ERBAKIR FEN LİSESİ",
        studentList: ["Deniz Demir Kartal", "Umut Kavuklu", "Yiğit Haydaroğlu"],
        tutorList: ["Kadir Balaban"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ftekden.png?alt=media&token=3bd55fc1-45eb-4852-89fc-775b5ae284a0",
        schoolName: "ÖZEL KAYSERİ TEKDEN FEN LİSESİ",
        studentList: ["Merve Özkol", "Umut Ezgintürk", "Yağız Bora Dalkılınç"],
        tutorList: ["Tuba Baykal"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fistanbul-erkek.png?alt=media&token=c021b917-d90d-42ca-b24e-18b1d0832c79",
        schoolName: "İSTANBUL ERKEK LİSESİ",
        studentList: ["Dide Elif Yeşilırmak", "Eymen Arslan", "Kerem Sarier"],
        tutorList: ["Murat Yoğurtçu"],
      }),
    ],
  });

  //ONBİRİNCİ SINIF
  const onbirinciSinifMedals = generateMedalGroup({
    groupName: "On Birinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fselcuklu-bilsem.jpg?alt=media&token=34dcd4f1-8ece-44ce-9c8b-3860e0b52695",
        schoolName: "SELÇUKLU BİLİM VE SANAT MERKEZİ",
        studentList: ["Arda Korkmaz", "Bedrettin Bera Kokulu", "Yavuz Mete Karagül"],
        tutorList: ["Çağrı Kemal Erdal"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fistanbul-erkek.png?alt=media&token=c021b917-d90d-42ca-b24e-18b1d0832c79",
        schoolName: "İSTANBUL ERKEK LİSESİ",
        studentList: ["Ayşe Melike Acar"],
        tutorList: ["Murat Yoğurtçu"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fbaskent-ayse.jpg?alt=media&token=cf9c38bf-4b5f-4e00-b285-e78785558a9d",
        schoolName: "BAŞKENT ÜNİVERSİTESİ ÖZEL AYŞEABLA FEN LİSESİ",
        studentList: ["Ahmet Özgür Bostancıoğlu", "Deniz Kaya", "Yağız Berk Kökmen"],
        tutorList: ["Özge Elif Ergün"],
      }),
    ],
  });

  //ONİKİNCİ SINIF
  const onikinciSinifMedals = generateMedalGroup({
    groupName: "On İkinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fistanbul-erkek.png?alt=media&token=c021b917-d90d-42ca-b24e-18b1d0832c79",
        schoolName: "İSTANBUL ERKEK LİSESİ",
        studentList: ["Barış Nişancı", "Muhammed Ali Yeniçeri", "Yusuf Ozan Aydın"],
        tutorList: ["Murat Yoğurtçu"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fbahcesehir.png?alt=media&token=c0af9945-dfac-4004-8000-2b6dfdbcb72a",
        schoolName: "ÖZEL ANTALYA LARA BAHÇEŞEHİR ANADOLU LİSESİ",
        studentList: ["Arda Aykut", "Mete Kanber", "Said Alparslan"],
        tutorList: ["Hilal Hatipoğlu"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fderece_alan_okullari%2Fdemirci-necip-faz%C4%B1l.jpg?alt=media&token=29c61644-de09-4eb4-aae9-d8f2f2f33289",
        schoolName: "DEMİRCİ NECİP FAZIL KISAKÜREK FEN LİSESİ",
        studentList: ["Ece Özcan", "Mehmet Dilşeker", "Nazlı Özcan"],
        tutorList: ["Seher Yaka"],
      }),
    ],
  });

  return (
    <div>
      {birinciSinifMedals}
      {ikinciSinifMedals}
      {ucuncuSinifMedals}
      {dorduncuSinifMedals}
      {besinciSinifMedals}
      {altinciSinifMedals}
      {yedinciSinifMedals}
      {sekizinciSinifMedals}
      {dokuzuncuSinifMedals}
      {onuncuSinifMedals}
      {onbirinciSinifMedals}
      {onikinciSinifMedals}
    </div>
  );
};

const PhotoGallery = () => {
  return (
    <div style={{ marginTop: "30px" }}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://halici.pixieset.com/turkiyezekaoyunlarisampiyonasi2025-2026/"
      >
        <Button size="large" color="secondary" variant="contained">
          GALERİYE ULAŞMAK İÇİN TIKLAYINIZ
        </Button>
      </a>
    </div>
  );
};
const ActiveCompetitions = () => {
  return (
    <div className={"card "} style={{ marginTop: "30px", width: "100%", maxWidth: "600px", margin: "30px auto" }}>
      <img
        style={{
          width: "85%",
          marginBottom: "10px",
          justifyContent: "center",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "50px",
          marginBottom: "50px",
          borderRadius: "15px",
        }}
        src="assets\images\oyun2026_banner.jpg"
        alt="Oyun 2026"
      ></img>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://oyun.tzv.org.tr/"
        style={{ display: "block", textAlign: "center" }}
      >
        <Button
          size="large"
          color="secondary"
          variant="contained"
          style={{ marginBottom: "10px", width: "90%", maxWidth: "400px" }}
          target="_blank"
        >
          YARIŞMA SAYFASINA ULAŞMAK İÇİN TIKLAYINIZ
        </Button>
      </a>
    </div>
  );
};
const Bulten = () => {
  return (
    <div
      className={"card " + classNames.long_description}
      // className={"card"}
      style={{ fontSize: "medium" }}
    >
      <h4 style={{ fontWeight: "bold", marginTop: 30, textAlign: "center" }}>
        Türkiye 7. Okullar Arası Zeka Oyunları Şampiyonası'nın Ödül Töreni
        ODTÜ Eğitim Fakültesi'nde Gerçekleştirildi!
      </h4>
      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fbulten_foto%2Fodul_toreni_foto.jpeg?alt=media&token=72e60ddb-ca80-4d99-ba8f-28719456a2aa"
        alt="ödül töreni fotoğrafı"
      ></img>
      <p></p>
      {/* <div
        className={"card " + classNames.sponsor_card}
        style={{ marginTop: 0 }}
      >
        <iframe
          width="560"
          maxWidth="100%"
          height="315"
          // maxHeight = "100%"
          src="https://www.youtube.com/embed/wX1SGCKw-qo"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div> */}
      <p>
        Türkiye Zeka Vakfının Millî Eğitim Bakanlığı ve TÜBİTAK'ın destekleriyle
        başlattığı, Türkiye İş Bankası'nın Ana Sponsorluğunu yaptığı "Türkiye 7.
        Okullar Arası Zeka Oyunları Şampiyonası"nın ödül töreni ODTÜ Eğitim Fakültesi'nde gerçekleştirildi.
      </p>
      <p>
        Türkiye genelinde 10.235  öğrencinin katıldığı Türkiye 7. Okullar Arası
        Zeka Oyunları Şampiyonası'nın ödül töreninde birinci sınıftan on ikinci
        sınıfa kadar ilk üç dereceyi alan okullara ödülleri Türkiye Zeka Vakfı
        Başkanı Emrehan Halıcı, Türkiye İş Bankası Genel Müdürü Hakan Aran, 
        Orta Doğu Teknik Üniversitesi rektörü Prof. Dr. Ahmet Yozgatlıgil
        Millî Eğitim Bakanlı Sayın Yusuf Tekin tarafından verildi.
      </p>

      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fbulten_foto%2Fkonusmacilar.png?alt=media&token=7655fb1b-d286-43a1-9fb0-5127bb3a3bf9"
        alt="konuşmacılar"
      ></img>
      <p></p>
      <p>
        Türkiye Okullar Arası Zeka Oyunları Şampiyonası’nın bütün sorularını hazırlayan Türkiye Zeka Vakfı Başkanı Emrehan Halıcı,  
        “Amacımız, daha iyi düşünen insanların yetişmesine ve çoğalmasına katkı yapmak.
         ‘Daha iyi düşünen insanlar’ derken, sadece kendini düşünenleri kastetmiyorum. 
         Kendisiyle birlikte diğer insanları, çevreyi, doğayı ve tüm canlıları düşünen insanları kastediyorum. 
         Kurnazlık ile zekâ arasındaki ince ama çok keskin çizgi de işte burada ortaya çıkar. 
         Diğer unsurları dikkate almadan sadece kendi çıkarını düşünmek, hak etmediği sonuçları hedeflemek, emek harcamadan başarıyı beklemek, amaca ulaşmak için her yolu mübah görmek kurnazlıkta karşımıza çıkar. 
         Oysa zekâ; bilgiyi, emeği ve sorumluluğu birleştirir. Ahlaki değerleri daima birinci sıraya koyar. Zekâda beyin çalışır; ama vicdanın da sesini dinler. 
         Gerçek zekâ, başkalarının mutsuzluğu üzerine kurulmuş mutlulukları kabul etmez. 
         Başarıyı yalnızca hedefe ulaşmak olarak değil, başkalarına zarar vermeden, onları da gözeterek, hak ederek, hakla, adaletle ulaşmak olarak görür.” dedi.
      </p>
      <p>
        Daha sonra söz alan etkinliğin ana sponsoru Türkiye İş Bankası Genel Müdürü Hakan Aran Türkiye’nin dört bir yanındaki yeteneklerin keşfedilmesi için uzun soluklu çalışmaların önemine dikkat çekerek, geçmişte satranç eğitimine verdikleri destek sayesinde şimdi dünya şampiyonlarının yetiştiğini hatırlattı. Benzer şekilde Türkiye Okullar Arası Zeka Oyunları Şampiyonası’nın da öğrencilerin analitik düşünme, problem çözme ve takım çalışması becerilerini geliştiren önemli bir platform olduğunu vurguladı.
 
Doğal zekâ ile yapay zekânın birlikte şekillendireceği gelecekte karmaşık problemlere çözüm üretebilen bireylerin daha da önem kazanacağını belirten Aran, zeka oyunları ve benzeri eğitim faaliyetlerinin gençleri bu geleceğe hazırlayan değerli çalışmalar arasında yer aldığını ifade etti. 
      </p>

      <p>
      Açılış konuşmaları, Orta Doğu Teknik Üniversitesi rektörü Prof. Dr. Ahmet Yozgatlıgil ile devam etti. Türkiye Okullar Arası Zeka Oyunları Şampiyonası finalistlerini ODTÜ’de ağırlamaktan büyük memnuniyet duyduklarını belirten Yozgatlıgil, Eğitim Fakültesi’nin alanında dünyanın en iyileri arasında yer aldığını kaydetti. Yozgatlıgil, ODTÜ’nün eğitimden teknolojiye, girişimcilikten bilime uzanan güçlü ekosistemiyle gençleri geleceğe hazırladığını vurguladı.
 
Yarışmada başarı gösteren öğrencileri, öğretmenleri ve velileri tebrik eden Yozgatlıgil, Türkiye’nin farklı şehirlerinden gelen bu gençlerin geleceğin bilim insanları, girişimcileri ve liderleri olacağına inandığını belirterek, finalistlerle ilerleyen yıllarda ODTÜ’nün öğrencileri olarak yeniden bir araya gelmeyi umut ettiğini söyledi.
      </p>

      <p>
    Ödül töreni açılışının son konuşmasını ise Milli Eğitim Bakanı Sayın Yusuf Tekin gerçekleştirdi. Öğrencilerin analitik düşünme, problem çözme ve muhakeme becerilerini geliştiren çalışmaların eğitim sisteminin vazgeçilmez bir parçası olduğunu belirterek, Türkiye Okullar Arası Zekâ Oyunları Şampiyonası’nın bu becerilerin erken yaşlarda desteklenmesine önemli katkı sunduğunu ifade etti. Tekin, Millî Eğitim Bakanlığı olarak eğitimde fırsat eşitliğini güçlendirmeye, teknolojik altyapıyı geliştirmeye ve öğrencileri yapay zekâ çağının gerektirdiği yetkinliklerle buluşturmaya yönelik çalışmalar yürüttüklerini söyledi.
 
Bakanlığın üniversiteler, sivil toplum kuruluşları ve alan uzmanlarıyla iş birliğine büyük önem verdiğini vurgulayan Tekin, Türkiye Ulusal Zekâ Ölçeği’nden zeka oyunlarına kadar pek çok alanda ortak çalışmalar yürüttüklerini belirtti. Türkiye Zekâ Vakfı ile sürdürülen iş birliğinin bu yaklaşımın önemli örneklerinden biri olduğunu ifade eden Tekin, öğrencilerin gelişimine katkı sağlayan vakıf yöneticilerini, öğretmenleri ve velileri tebrik ederek yarışmada dereceye giren öğrencileri kutladı.

      </p>
      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_25-26%2Fbulten_foto%2Fkupa-ogrenci.jpg?alt=media&token=d3ff5d7f-7fb1-4fa2-8d65-1a8cd96f252c"
        alt="kupa teslimi"
      ></img>
    </div>
  );
};

function toTurkishTitleCase(str) {
  return str
    .toLocaleLowerCase("tr-TR")
    .split(" ")
    .map((word) => word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1))
    .join(" ");
}
